module.exports = __webpack_public_path__ + "static/media/icon_1_1.e4ef1be2.svg";